import { GetMultiUploadJobByFilenameResult, LibraryState, MultiUploadJob } from '@/modules/library/types'
import { TeamLibraryConst } from '@/constants/teamlibrary'

const helpers = {
  getMultiUploadJobTrackedFileIndex(multiUploadJob: MultiUploadJob, filename: string): number {
    return multiUploadJob.files.findIndex(function (element) {
      return (element.fileHandle !== null && element.fileHandle !== undefined && element.fileHandle.name === filename)
    })
  },
  getMultiUploadJobByFilename(state: LibraryState, filename: string): GetMultiUploadJobByFilenameResult {
    for (const multiUploadJob of state.jobs) {
      if (multiUploadJob.files) {
        const index = this.getMultiUploadJobTrackedFileIndex(multiUploadJob, filename)
        if (index >= 0) {
          return {
            multiUploadJob: multiUploadJob,
            uploadIndex: index,
          }
        }
      }
    }
    return {
      multiUploadJob: null,
      uploadIndex: -1,
    }
  },
  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes'

    const k: TeamLibraryConst.FileSizeUnit = TeamLibraryConst.FileSizeUnit.kb

    const sizes = ['Bytes', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i]
  }
}
export default helpers
